import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as PageRoutes from './../../utils/route_pages';
import * as Assets from './../../utils/svg_assets';
import {
  getIconFromOrg,
  getLocalStorage,
  setLocalStorage,
} from '../../utils/utilities';
import './style.scss';

const Menu = (props) => {
  const { onHandleOther = () => {}, isShowOther } = props;
  const navigate = useNavigate();
  const orgData = useSelector((state) => state.LoginSM.orgData);

  const currentFavorites = getLocalStorage('favorites-menu', true);
  const currentOthers = getLocalStorage('others-menu', true);
  const [isEdit, setIsEdit] = useState(false);

  const initMenus = [
    {
      id: 1,
      name: 'Quiz',
      path: '/quiz',
      icon:
        Object.keys(orgData).length > 0
          ? getIconFromOrg(orgData, 'icon_module_quiz')
          : Assets.iconQuiz,
    },
    {
      id: 2,
      name: 'News',
      path: PageRoutes.news,
      icon:
        Object.keys(orgData).length > 0
          ? getIconFromOrg(orgData, 'icon_module_news')
          : Assets.iconNews,
    },
    {
      id: 3,
      name: 'Survey',
      path: '/survey',
      icon: getIconFromOrg(orgData, 'icon_module_survey')
        ? getIconFromOrg(orgData, 'icon_module_survey')
        : Assets.iconSurvey,
    },
    {
      id: 4,
      name: 'Announcement',
      path: '/announcement',
      icon: getIconFromOrg(orgData, 'icon_module_announcement')
        ? getIconFromOrg(orgData, 'icon_module_announcement')
        : Assets.iconAnnouncement,
    },
    {
      id: 5,
      name: 'Receipt',
      path: '/snap-receipt',
      icon: getIconFromOrg(orgData, 'icon_module_calendar')
        ? getIconFromOrg(orgData, 'icon_module_calendar')
        : Assets.iconReceipt,
    },
    {
      id: 6,
      name: 'Polling',
      path: '/polling',
      icon: getIconFromOrg(orgData, 'icon_module_polling')
        ? getIconFromOrg(orgData, 'icon_module_polling')
        : Assets.iconPolling,
    },
    {
      id: 7,
      name: 'Event',
      path: '/event',
      icon: getIconFromOrg(orgData, 'icon_module_event')
        ? getIconFromOrg(orgData, 'icon_module_event')
        : Assets.iconEvent,
    },
    {
      id: 8,
      name: 'Others',
      path: '/other',
      icon: Assets.iconOther,
    },
  ];

  const [menus, setMenus] = useState(initMenus);

  const otherMenus = [
    {
      id: 9,
      name: 'Calendar',
      path: '/calendar',
      icon: getIconFromOrg(orgData, 'icon_module_calendar')
        ? getIconFromOrg(orgData, 'icon_module_calendar')
        : Assets.iconDateCalendar,
    },
    {
      id: 10,
      name: 'Leaderboard',
      path: '/leaderboard',
      icon: getIconFromOrg(orgData, 'icon_module_leaderboard')
        ? getIconFromOrg(orgData, 'icon_module_leaderboard')
        : Assets.iconLeaderboard,
    },
  ];

  const [favorites, setFavorites] = useState(currentFavorites ?? initMenus);
  const [others, setOtherMenu] = useState(currentOthers ?? otherMenus);

  const addToFavorites = (item) => {
    // Add item to favorites and remove it from otherMenu
    const newItem = {
      id: item.id,
      name: item.name,
      icon: item.icon,
      path: item.path,
    };
    setFavorites([newItem, ...favorites]);
    setOtherMenu(others.filter((other) => other.id !== item.id));
  };

  const removeFromFavorites = (item) => {
    // Remove item from favorites and add it back to otherMenu
    const newItem = {
      id: item.id,
      name: item.name,
      icon: item.icon,
      path: item.path,
    };
    setFavorites(favorites.filter((favorite) => favorite.id !== item.id));
    setOtherMenu([...others, newItem]);
  };

  const onHandleEdit = () => {
    setIsEdit(!isEdit);
  };

  const onHandleSave = () => {
    const favoriteMenu = favorites.filter((item) => item.name !== 'Others');
    if (favoriteMenu) {
      const otherItem = {
        id: 8,
        name: 'Others',
        path: '/other',
        icon: Assets.iconOther,
      };
      setFavorites([...favorites, otherItem]);
      console.log('Main => ', favorites);
    }
    // setLocalStorage('favorites-menu', JSON.stringify(favorites));
    setLocalStorage('others-menu', JSON.stringify(others));
    onHandleEdit();
    onHandleOther();
  };

  useEffect(() => {
    if (!isShowOther) {
      const favoriteMenu = favorites.filter((item) => item.name !== 'Others');
      if (favoriteMenu) {
        const otherItem = {
          id: 8,
          name: 'Others',
          path: '/other',
          icon: Assets.iconOther,
        };
        setFavorites([...favorites, otherItem]);
        setLocalStorage('favorites-menu', JSON.stringify(favorites));
      }
      setMenus(favorites);
    } else {
      setFavorites(favorites.filter((item) => item.name !== 'Others'));
    }
  }, [isShowOther]);

  const clearInvalidOthers = () => {
    setOtherMenu(
      others.filter((item) => item.icon !== undefined && item.icon !== null)
    );
  };

  useEffect(() => {
    clearInvalidOthers();
  }, []);

  return (
    <div>
      {!isShowOther ? (
        <div id="menus" className="my-4">
          <div className="menu-list">
            {menus.map((menu) => (
              <div
                key={menu.id}
                className="menu-link"
                onClick={() => {
                  if (!isEdit) {
                    if (menu.name === 'Others') {
                      onHandleOther();
                    } else {
                      navigate(menu.path);
                    }
                  }
                }}
              >
                <div className="icon-wrapper">
                  <img
                    src={menu?.icon}
                    width="24px"
                    alt={`Icon ${menu?.name}`}
                  />
                </div>
                <span className="menu-title">{menu.name}</span>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div>
          <div className="d-flex justify-content-between align-items-center mh-12px mt-3">
            <h3
              className="mb-0"
              style={{
                fontSize: '16px',
                fontWeight: 'bold',
              }}
            >
              Your Favorites
            </h3>
            {!isEdit ? (
              <div className="actions d-flex">
                <button className="cancel-btn" onClick={onHandleEdit}>
                  Edit
                </button>
              </div>
            ) : (
              <div className="actions d-flex">
                <button className="cancel-btn" onClick={onHandleSave}>
                  Done
                </button>
              </div>
            )}
          </div>
          <div id="menus" className="my-4">
            <div className="menu-list">
              {favorites.map((menu) => (
                <div
                  key={menu.id}
                  className="menu-link"
                  onClick={() => {
                    if (!isEdit && menu.name !== 'Others') navigate(menu.path);
                  }}
                >
                  {isEdit && menu.name !== 'Others' ? (
                    <img
                      src={Assets.iconDeleteMenu}
                      alt="delete-icon"
                      className="delete-icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (menu) removeFromFavorites(menu);
                      }}
                    />
                  ) : null}
                  <div className="icon-wrapper">
                    <img
                      src={menu?.icon}
                      width="24px"
                      alt={`Icon ${menu?.name}`}
                    />
                  </div>
                  <span className="menu-title">{menu.name}</span>
                </div>
              ))}
            </div>
          </div>
          <h3
            className="mb-0"
            style={{ fontSize: '16px', marginLeft: '12px', fontWeight: 'bold' }}
          >
            Other Menu
          </h3>
          <div id="menus" className="my-4">
            <div className="menu-list">
              {others.map((menu) => (
                <div
                  key={menu?.id}
                  className="menu-link"
                  onClick={() => {
                    if (!isEdit) navigate(menu?.path);
                  }}
                >
                  {isEdit && favorites.length < 7 ? (
                    <img
                      src={Assets.iconPlus}
                      alt="add-icon"
                      className="add-icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (menu) addToFavorites(menu);
                      }}
                    />
                  ) : null}
                  <div className="icon-wrapper">
                    <img
                      src={menu?.icon}
                      width="24px"
                      alt={`Icon ${menu?.name}`}
                    />
                  </div>
                  <span className="menu-title">{menu?.name}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Menu;
